import React from 'react';
import YoutubePlaylistsApi from '../../components/admin/YoutubePlaylistsApi';

const YoutubePlaylistsApiPage = () => {
  return <YoutubePlaylistsApi />;
};

export default YoutubePlaylistsApiPage;
